import { TFilterIds } from '../types';

export const getFilterIdFromContentUrl = (contentUrl: string) =>
  contentUrl.replace('api/v2/filters/', '').replace('/content', '') as TFilterIds;
